/**
 * Utility for managing scroll position between page navigations
 * Specifically designed to maintain scroll position when navigating back from work pages to landing page
 * Integrates with Lenis smooth scrolling library
 */
import { getLenisInstance } from './smoothScroll'

// Save the current scroll position for a specific path
export const saveScrollPosition = (path) => {
  if (typeof window !== 'undefined') {
    // Try to get scroll position from Lenis first
    const lenis = getLenisInstance()
    const scrollPosition = lenis ? lenis.scroll : (window.scrollY || window.pageYOffset)
    sessionStorage.setItem(`scrollPosition_${path}`, scrollPosition.toString())
  }
}

// Restore the scroll position for a specific path
export const restoreScrollPosition = (path) => {
  if (typeof window !== 'undefined') {
    const savedPosition = sessionStorage.getItem(`scrollPosition_${path}`)
    if (savedPosition !== null) {
      const position = parseInt(savedPosition, 10)
      
      // Use Lenis for smooth scrolling if available
      const lenis = getLenisInstance()
      if (lenis && typeof lenis.scrollTo === 'function') {
        // Small delay to ensure DOM is ready
        setTimeout(() => {
          lenis.scrollTo(position, { immediate: true })
        }, 50)
      } else {
        // Fallback to standard scrollTo
        setTimeout(() => {
          window.scrollTo(0, position)
        }, 50)
      }
    }
  }
}

// Check if the navigation is a "back" navigation
export const isBackNavigation = () => {
  if (typeof window !== 'undefined') {
    // Modern browsers
    if (window.performance && window.performance.getEntriesByType) {
      const navigationEntries = window.performance.getEntriesByType('navigation')
      if (navigationEntries.length > 0) {
        return navigationEntries[0].type === 'back_forward'
      }
    }
    
    // Fallback for older browsers
    if (window.performance && 
        window.performance.navigation && 
        window.performance.navigation.type === window.performance.navigation.TYPE_BACK_FORWARD) {
      return true
    }
    
    return false
  }
  return false
}
